import { render, staticRenderFns } from "./EnrollmentInitiatializeForm.vue?vue&type=template&id=1d84961c&scoped=true"
import script from "./EnrollmentInitiatializeForm.vue?vue&type=script&lang=js"
export * from "./EnrollmentInitiatializeForm.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentInitiatializeForm.vue?vue&type=style&index=0&id=1d84961c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84961c",
  null
  
)

export default component.exports